// extracted by mini-css-extract-plugin
export default {"updateButtonActive":"UpdateListButton_updateButtonActive__02kyx","updateButton":"UpdateListButton_updateButton__LeFRj"};